class MCartDrawer extends HTMLElement {
  constructor() {
    super()
    this.cartDrawerInner = this.querySelector('.m-cart-drawer__inner');
    this.cartDrawerCloseIcon = this.querySelector('.m-cart-drawer__close');
    this.cartOverlay = this.querySelector('.m-cart__overlay');
    this.rootUrl = window.Shopify.routes.root;
    this.activeDrawerTab = 'in_stock';

    this.setHeaderCartIconAccessibility();
    this.cartDrawerCloseIcon.addEventListener('click', this.close.bind(this));
    this.addEventListener('click', this.onCartDrawerClick.bind(this));
    this.addEventListener('click', (event) => {
      if (event.target.closest('.m-cart-drawer__inner') !== this.cartDrawerInner) {
        this.close();
      }
    });
    this.syncDrawerTabs();
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll('.m-cart-icon-bubble')
    cartLinks.forEach(cartLink => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        if (MinimogSettings.enable_cart_drawer) {
          event.preventDefault();
          this.open(cartLink)
        }
      });
    })
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.classList.add('m-cart-drawer--active');
    requestAnimationFrame(() => {
      this.style.setProperty('--m-bg-opacity', '0.5');
      this.cartDrawerInner.style.setProperty('--translate-x', '0');
    })
    window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);
    // document.documentElement.classList.add('prevent-scroll');
  }

  close() {
    this.style.setProperty('--m-bg-opacity', '0');
    this.cartDrawerInner.style.setProperty('--translate-x', '100%');
    setTimeout(() => {
      this.classList.remove('m-cart-drawer--active');
      // document.documentElement.classList.remove('prevent-scroll');
    }, 300)
  }

  renderContents(parsedState) {
    this.classList.contains('m-cart--empty') && this.classList.remove('m-cart--empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    this.syncDrawerTabs();
    setTimeout(() => {
      this.open()
    });
  }

  updateCartCount(itemCount) {
    const cartCounts = document.querySelectorAll('.m-cart-count-bubble');
    cartCounts.forEach(cartCount => {
      if (itemCount > 0) {
        cartCount.textContent = itemCount
        cartCount.classList.remove('m:hidden')
      } else {
        cartCount.classList.add('m:hidden')
      }

    })
  }

  getCart() {
    return fetchJSON(this.rootUrl + 'cart.json');
  }

  onCartDrawerUpdate(updateFooter = true) {
    fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`)
      .then(response => response.text())
      .then(responseText => {
        this.getSectionsToRender().forEach((section => {
          if (section.block === 'cart-items') {
            const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
            sectionElement.innerHTML = this.getSectionInnerHTML(responseText, section.selector);
          } else {
            if (updateFooter) {
              const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
              sectionElement.innerHTML = this.getSectionInnerHTML(responseText, section.selector);
            }
          }
        }));
        this.syncDrawerTabs();
      })
      .catch(e => {
        console.error(e);
      });
      this.getCart().then(cart => {
        this.classList.toggle('m-cart--empty', cart.item_count === 0);
        this.updateCartCount(cart.item_count);
      })
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {  
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '[data-minimog-cart-items]',
        block: 'cart-items'
      },
      {
        id: 'cart-drawer',
        selector: '[data-minimog-cart-discounts]',
        block: 'cart-footer'
      },
      {
        id: 'cart-drawer',
        selector: '[data-cart-subtotal]',
        block: 'cart-footer'
      },
      {
        id: 'cart-drawer',
        selector: '[data-minimog-gift-wrapping]',
        block: 'cart-footer'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  onCartDrawerClick(event) {
    const checkoutButton = event.target.closest('[data-ajax-cart-checkout]');
    if (checkoutButton && this.contains(checkoutButton)) {
      this.checkoutByActiveTab(event, checkoutButton);
      return;
    }

    const tabButton = event.target.closest('[data-ajax-cart-tab]');
    if (!tabButton || !this.contains(tabButton)) return;

    event.preventDefault();
    this.activeDrawerTab = tabButton.dataset.ajaxCartTab || 'in_stock';
    this.syncDrawerTabs();
  }

  checkoutByActiveTab(event, checkoutButton) {
    const tabs = this.querySelectorAll('[data-ajax-cart-tab]');
    if (!tabs.length) return;

    if (checkoutButton.disabled || checkoutButton.dataset.processing === 'true') {
      event.preventDefault();
      return;
    }

    const selectedBucket = this.activeDrawerTab || 'in_stock';
    const cartItems = Array.from(this.querySelectorAll('[data-cart-item][data-cart-bucket][data-cart-key]'));
    if (!cartItems.length) return;

    const updates = {};
    let selectedItemCount = 0;

    cartItems.forEach((item) => {
      const cartKey = item.dataset.cartKey;
      if (!cartKey) return;

      const quantityInput = item.querySelector('input[name="updates[]"]');
      const quantity = Math.max(parseInt(quantityInput?.value, 10) || 0, 0);

      if (item.dataset.cartBucket === selectedBucket && quantity > 0) {
        updates[cartKey] = quantity;
        selectedItemCount += quantity;
      } else {
        updates[cartKey] = 0;
      }
    });

    if (!Object.keys(updates).length || !selectedItemCount) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    checkoutButton.dataset.processing = 'true';
    checkoutButton.disabled = true;
    checkoutButton.classList.add('m-loading');
    checkoutButton.setAttribute('aria-busy', 'true');

    fetchJSON(this.rootUrl + 'cart/update.js', {
      mode: 'same-origin',
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates }),
    })
      .then(() => {
        window.location.href = this.rootUrl + 'checkout';
      })
      .catch((error) => {
        console.error(error);
        checkoutButton.disabled = false;
      })
      .finally(() => {
        checkoutButton.dataset.processing = 'false';
        checkoutButton.classList.remove('m-loading');
        checkoutButton.removeAttribute('aria-busy');
      });
  }

  syncDrawerTabs() {
    const tabs = Array.from(this.querySelectorAll('[data-ajax-cart-tab]'));
    const panels = Array.from(this.querySelectorAll('[data-ajax-cart-panel]'));
    if (!tabs.length || !panels.length) return;

    let activeTab = this.activeDrawerTab || 'in_stock';
    const tabExists = panels.some((panel) => panel.dataset.ajaxCartPanel === activeTab);
    if (!tabExists) {
      activeTab = panels[0].dataset.ajaxCartPanel;
    }

    const activePanel = panels.find((panel) => panel.dataset.ajaxCartPanel === activeTab);
    if (activePanel && activePanel.dataset.hasItems === 'false') {
      const panelWithItems = panels.find((panel) => panel.dataset.hasItems === 'true');
      if (panelWithItems) {
        activeTab = panelWithItems.dataset.ajaxCartPanel;
      }
    }

    this.activeDrawerTab = activeTab;

    tabs.forEach((tab) => {
      const isActive = tab.dataset.ajaxCartTab === activeTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach((panel) => {
      const isActive = panel.dataset.ajaxCartPanel === activeTab;
      panel.classList.toggle('m:hidden', !isActive);
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }
}

customElements.define('m-cart-drawer', MCartDrawer)

class MCartDrawerItems extends MCartTemplate {
  getSectionsToRender() {
    return [
      {
        id: 'MinimogCartDrawer',
        section: 'cart-drawer',
        selector: '[data-minimog-cart-items]'
      },
      {
        id: 'MinimogCartDrawer',
        section: 'cart-drawer',
        selector: '[data-minimog-cart-discounts]'
      },
      {
        id: 'MinimogCartDrawer',
        section: 'cart-drawer',
        selector: '[data-cart-subtotal]'
      },
      {
        id: 'MinimogCartDrawer',
        section: 'cart-drawer',
        selector: '[data-minimog-gift-wrapping]'
      }
    ];
  }
}

customElements.define('m-cart-drawer-items', MCartDrawerItems);
